import { constants } from "@newsela/angelou";

import uiTypes from "@/view/constants/uiTypes";

const { colors } = constants;

const brandPink = colors.ui.pink[50];
const statusBlue = colors.status.info[25];

export const uiBackgroundColor = (uiType) => {
  let backgroundColor = statusBlue;
  if (uiType === uiTypes.LITE) {
    backgroundColor = brandPink;
  }

  return backgroundColor;
};
